/* global fetchAPI */
export const initializeTimes = () => fetchAPI(new Date());